import Cookies from 'js-cookie'
import md5 from 'md5'
let env_str = 'szyc_' + md5(location.host + process.env.VUE_APP_BASE_API).slice(0, 4) + '_'
export const cookiesList = {
  user_type: env_str + 'pc_user_type',
  token: env_str + 'pc_token_20201207',
  user_id: env_str + 'pc_user_id',
  account: env_str + 'pc_user_account',
  has_password: env_str + 'pc_pwd_set',
  merchant_id: env_str + 'pc_merchant_id'
}

export function setCookie (key, value) {
  return Cookies.set(key, value, { expires: 7 })
}

export function getCookie (key) {
  return Cookies.get(key)
}

export function removeCookie (key) {
  return Cookies.remove(key)
}

// 删除所有 cookie
function delAllCookie() {
  let expires = new Date(0).toUTCString();
  let cookieStr = document.cookie;
  let cookieList = cookieStr.split('; ');
  for (let i = 0; i < cookieList.length; i ++) {
    let key = cookieList[i].split('=')[0]
    console.log(key)
    // 运营供应商的id缓存保留
    if (key !=  env_str + 'pc_merchant_id') {
      document.cookie = key + '=; expires=' + expires
    }
  }
}

export function clearLoginData () {
  // 删除所有cookie
  delAllCookie();

  // 删除列表中的cookie
  // for (let key in cookiesList) {
  //   Cookies.remove(cookiesList[key])
  // }
}

export function getToken() {
  return Cookies.get(cookiesList.token)
}

export function setToken() {
  return Cookies.set(cookiesList.token)
}

export function removeToken() {
  return Cookies.remove(cookiesList.token)
}
